import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_b78645e2-7e54-4fc5-b6dd-84c8c35b28ff/artifacts/60ni2i2y_FullLogo%20%281%29.jpg";

const About = () => {
  return (
    <div className="py-20" data-testid="about-page">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="text-[10px] tracking-[0.35em] uppercase text-amber-300/70 mb-4">✦ Our Story ✦</div>
          <h1 className="font-serif text-5xl sm:text-6xl text-amber-50" data-testid="about-title">
            From spray tans to <span className="italic text-pink-300">full service luxury</span>
          </h1>
        </div>

        <div className="rounded-2xl border border-amber-900/30 bg-[#0a0405] p-10 md:p-14">
          <div className="flex flex-col md:flex-row items-center gap-10">
            <img src={LOGO_URL} alt="24K Glow On The Go" className="w-40 h-40 object-contain flex-shrink-0" data-testid="about-logo" />
            <div className="space-y-5 text-amber-100/80 leading-relaxed text-base">
              <p>
                <span className="font-serif text-2xl text-amber-100 block mb-2">It started with one mission.</span>
                Bring luxury beauty to women who deserved it — without making them sit in salon chairs, fight traffic, or sacrifice their entire afternoon.
              </p>
              <p>
                <span className="text-amber-200 font-medium">24K Glow On The Go</span> began as a luxury mobile spray tan service. Clients loved it. They asked for more. Nails. Facials. Makeup. Hair.
              </p>
              <p>
                Today, the brand has grown into <span className="text-pink-300 font-medium">Monthly Glow On The Go</span> — your full mobile salon, available across all of Northeast Florida & Southern Georgia, powered by patent-pending 3D AI nail art technology and a monthly subscription model that puts luxury within reach.
              </p>
              <p className="italic text-amber-200/80 font-serif text-lg">
                "24K luxury. On the go. Always."
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center" data-testid="meet-christina">
          <div className="text-[10px] tracking-[0.35em] uppercase text-amber-300/70 mb-3">Meet Your Artist</div>
          <h2 className="font-serif text-4xl text-amber-50">Christina Sunshine</h2>
          <p className="mt-3 text-amber-100/60 max-w-xl mx-auto">
            Owner & Chief of Operations · Licensed Esthetician · Nail Tech · Spray-Tan Artist
          </p>
        </div>

        <div className="mt-16 text-center">
          <Link to="/plans" className="inline-block px-10 py-4 rounded-full bg-pink-300 text-black font-medium hover:bg-pink-200 transition-all" data-testid="about-cta">
            Join the Glow Family
          </Link>
        </div>
      </div>
    </div>
  );
};

export default About;
